export default {
  "group1": {
    main: "#f75b5b",
    font: "#000000",
    align: "top",
  },
  "group2": {
    main: "#b3bccc",
    font: "#000000",
    align: "top",
  },
  "group3": {
    main: "#ffc700",
    font: "#000000",
    align: "top",
  },
  "group4": {
    main: "#5e6d82",
    font: "#ffffff",
    align: "bottom",
  },
}
